import { EChartsOption } from "echarts-for-react/lib/types"

export const DefaultChartOption: EChartsOption = {
  calculable: false,
  grid: {
    // 距离右边的距离
    bottom: 40,
    containLabel: true,
    left: "0",
    // 距离左边的距离
    right: "0",
    x: 20,
    x2: 20,
    y: 35,
  },
  legend: {
    orient: "horizontal",
    show: true,
    left: "center",
    bottom: 0,
    data: [
      // {
      //   name: "Return Requests",
      //   icon: "roundRect",
      // }, // 第一个图例使用圆形
      // {
      //   name: "Returns aaaa",
      //   // icon: "path://M0 5 H1 M2 5 H3 M4 5 H5 M6 5 H7", // 三个小点的虚线
      //   Icon: "rect",
      // },
    ],
    itemWidth: 12,
    itemHeight: 2,
    selectedMode: true, // 可点击图例
    textStyle: {
      fontSize: 13,
    },
  },
  series: [
    {
      // 设定实心点的大小
      data: [],
      emphasis: {},
      itemStyle: {
        color: "#0067FF",
      },
      markPoint: {
        label: {
          color: "#fff", // markPoint 标记文字颜色设置为白色
        },
      },
      name: "Return Requests",
      symbol: "circle",
      symbolSize: 1,
      type: "line",
      // smooth: true,
      areaStyle: {
        color: "#0067FF",
        opacity: 0.8,
      },
      lineStyle: {
        color: "#1BA2DD", // 线条颜色
        width: 1.5, // 线条宽度
        shadowColor: "rgba(132, 202, 233, 0.5)", // 阴影颜色
        shadowBlur: 10, // 阴影模糊大小
        shadowOffsetX: 4, // 阴影 X 轴偏移
        shadowOffsetY: 4, // 阴影 Y 轴偏移
        type: "solid",
      },
      label: {
        show: false,
        formatter: `{c}%`,
      },
    },
    {
      // 设定实心点的大小
      data: [],
      emphasis: {},
      itemStyle: {
        color: "#84CBEA",
      },
      markPoint: {
        label: {
          color: "#fff", // markPoint 标记文字颜色设置为白色
        },
      },
      name: "Return Requests",
      symbol: "circle",
      symbolSize: 1,
      type: "line",
      smooth: true,
      lineStyle: {
        // 使用圆点虚线样式
        type: "dotted",
        width: 2, // 适当加粗线条
        color: "#84CBEA",
        dashOffset: 4, // 增大虚线间距
        // 注意：ECharts 的 dotted 虚线间距受 symbolSize、width、dashOffset 影响
      },
      label: {
        show: false,
        formatter: `{c}%`,
      },
      // 通过设置sampling为'none'，确保点与点之间不会被自动插值
      // sampling: "none",
    },
  ],
  title: {
    bottom: 20,
    left: 16,
    text: "",
    textStyle: {
      color: "#637381",
      fontSize: 13,
      fontStyle: "normal",
      fontWeight: "normal",
    },
  },
  tooltip: {
    backgroundColor: "#ffffff",
    // borderColor: "#cccccc",
    borderWidth: "1",
    // 通过设置rgba调节背景颜色与透明度
    color: "black",
    // 触发类型：坐标轴触发
    confine: true,
    // 使得tooltip一直在容器中 而不会超出
    extraCssText: "z-index: 2",
    // position: function (
    //   point: any,
    //   params: any,
    //   dom: any,
    //   rect: any,
    //   size: any,
    // ) {
    //   // 其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
    //   const x = point[0] //
    //   const y = point[1]
    //   // var viewWidth = size.viewSize[0];
    //   // var viewHeight = size.viewSize[1];
    //   const boxWidth = size.contentSize[0]
    //   const boxHeight = size.contentSize[1]
    //   let posX = 0 // x坐标位置
    //   let posY = 0 // y坐标位置
    //   if (x - 30 < boxWidth) {
    //     // 左边放不开
    //     posX = 165
    //   } else {
    //     // 左边放的下
    //     posX = x - boxWidth
    //   }
    //   if (y < boxHeight) {
    //     // 上边放不开
    //     posY = 5
    //   } else {
    //     // 上边放得下
    //     posY = y - boxHeight
    //   }
    //   return [posX, posY]
    // },
    textStyle: {
      color: "#303030",
      fontSize: 13,
      fontStyle: "normal",
      fontWeight: "normal",
    },
    trigger: "axis",
  },
  xAxis: [
    {
      // X 轴数据
      axisLabel: {
        align: "center",
        color: "#637381",
      },
      axisTick: {
        alignWithLabel: true,
      },
      boundaryGap: ["0", "0.1"],
      // 距离坐标原点是否有间隙
      data: [],
      type: "category",
    },
  ],
  yAxis: [
    {
      axisLabel: {
        color: "#637381",
        fontSize: "12",
        formatter: "{value}",
      },
      // 改变x轴字体颜色和大小
      max: function (value: any) {
        if (value.max < 5) {
          return 5
        }
        return null
      },
      minInterval: 1,
      type: "value",
    },
  ],
}
